import { pickBy, pick, debounce } from 'lodash';
import AnalysysAgent$1 from 'ans-javascript-sdk';

// 从 npm 获取 sdk

var AnalysysAgent = buildProperties => ({
    /**
     *
     * @param {*} config { appkey, debugMode, uploadURL }
     * @param {*} superProperties { userID, level, deviceId, }
     */
    init(config, superProperties) {
        let { appkey, debugMode = 0, uploadURL } = config;
        if (!appkey) {
            throw new Error('must config the appkey of yiguan');
        }
        if (!uploadURL) {
            throw new Error('must config the uploadURL of yiguan server');
        }
        uploadURL = uploadURL || 'https://ark-collector.aikucun.com';
        console.log('init track config', config);
        console.log('init track superProperties', superProperties);
        AnalysysAgent$1.init({
            appkey, // APPKEY
            uploadURL, // 上传数据的地址
            debugMode,
            auto: false,
            sendType: 'post',
        });
        if (superProperties) {
            this.registerSuperProperty(superProperties);
        }
    },
    /**
     *
     * h5: @param {
     * shop_id, // 店铺ID
     * serverId, // 服务者ID
     * serverRole: serverId ? '2' : '3', // 店长2 店主3
     * shareId, // 分享者ID
     * shareRole, // 分享者角色
     * client: 'h5',
     * t,
     * source
     * }
     * app: @param {
     * userID, // 用户id
     * level, // 店主等级
     * deviceId // 设备id
     * }
     */
    registerSuperProperty(superProperties) {
        // keys不做限制
        // let keys = [
        //     'userID',
        //     'level',
        //     'deviceId',
        //     'shop_id', // 店铺ID
        //     'serverId', // 服务者ID
        //     'serverRole', // 店长2 店主3
        //     'shareId', // 分享者ID
        //     'shareRole', // 分享者角色
        //     'client',
        //     't',
        //     'source',
        //     'common_id',
        //     '$session_id',
        // ];
        let props = pickBy(superProperties, (v, k) => v !== undefined && v != null && v !== '');
        if (props) {
            if (props.userID) {
                AnalysysAgent$1.alias(props.userID);
            }
            let { userID, ...others } = props;
            console.log('set track superProperties', props, others);
            if (Object.keys(others).length) {
                AnalysysAgent$1.registerSuperProperties(others);
            }
        }
    },
    alias(user) {
        if (user) {
            AnalysysAgent$1.alias(user);
        }
    },
    track(eventName, properties) {
        try {
            let props = buildProperties(eventName, properties);
            console.log('track', eventName, props);
            AnalysysAgent$1.track(eventName, props);
        } catch (e) {
            console.error(e);
        }
    },
    pageView(properties) {
        try {
            let props = buildProperties('pv', properties);
            console.log('track pageview', props);
            if (!props || !props.page_name) {
                throw new Error('pageview\'s page_name is blank');
            }
            AnalysysAgent$1.pageView(props);
        } catch (e) {
            console.error(e);
        }
    },
});

/* eslint-disable no-unused-vars */

/**
 * yiguan埋点参数
 * @param {*} keys
 */
const akcAppProperties = keys => (to, from) => defaults => {
    if (!to && !from && defaults) {
        defaults = to;
        to = null;
        from = null;
    }
    const properties = {
        get page_name() {
            let page = window.location.href.match(/.*?\/([^/]+).html/);
            page = page && page[1];
            if (page === 'commonActivity' && to && to.name === 'index') return '会场';
            if (page === 'superBrand' && to && to.name === 'index') return '超级会场';

            return to && to.meta ? to.meta.page_name : '';
        },
        get previous_page_name() {
            let preName = from && from.meta ? from.meta.page_name : '';
            let name = from ? preName || from.name : '';
            if (!name) {
                name = window.location.href.match(/[?&]previous_page_name=([^&]+)/);
                name = name && window.decodeURIComponent(name && name[1]);
            }
            return name;
        },
        get activity_id() {
            const id = window.location.href.match(/activityNo=([^&]+)/);
            return id ? id[1] : '';
        },
        get market_id() {
            const id = window.location.href.match(/hotSaleId=([^&]+)|conferenceId=([^&]+)/);
            return id ? (id[1] || id[2]) : '';
        },
        get live_status() {
            return '';
        },
        get live_no() {
            const id = window.location.href.match(/liveNo=([^&]+)/);
            return id ? id[1] : '';
        },
        get page_desc() {
            return '';
        },
        tab_id: '',
        tab_name: '',
        rank: '',
        nums: '',
        resource_id: '',
        resource_name: '',
        resource_content: '',
        resource_type: '',
        resource_url: '',
        resource_rank: '',
        rank_name: '',
        rank_type: '',
        filter_text: '',
        uuid: '',
        click_activity_id: '',
        click_product_id: '',
        click_market_id: '',
        click_live_status: '',
        click_live_no: '',
        click_coupons_id: '',
        desc: '',
        share_type: '',
        share_method: '',
        click_tag_id: '',
        share_channel: '',
        share_setting: '',
        share_t: '',
        img_type: '',
        is_success: '',
        reason: '',
        choose_type: '',
    };

    const props = { ...properties, ...defaults };
    [
        'click_activity_id',
        'click_product_id',
        'click_market_id',
        'click_coupons_id',
        'market_id',
        'activity_id',
        'tab_id',
        'live_no',
        'resource_id',
    ].forEach(k => {
        props[k] = typeof props[k] === 'number' ? String(props[k]) : props[k];
    });
    return pickBy(pick(props, keys), (v, k) => v !== undefined && v != null && v !== '');
};

const pv = akcAppProperties([
    '$url',
    '$referrer',
    'page_name',
    'previous_page_name',
    'activity_id',
    'market_id',
    'live_status',
    'live_no',
    'page_desc',
    'material_id',
    'channel',
]);

const tab_expose = akcAppProperties([
    'page_name',
    'previous_page_name',
    'activity_id',
    'market_id',
    'live_status',
    'live_no',
    'page_desc',
    'tab_id',
    'tab_name',
    'rank',
    'nums',
]);

const resource_expose = akcAppProperties([
    'page_name',
    'previous_page_name',
    'activity_id',
    'market_id',
    'live_status',
    'live_no',
    'page_desc',
    'tab_name',
    'resource_id',
    'resource_name',
    'resource_content',
    'resource_type',
    'resource_url',
    'resource_rank',
    'rank',
    'rank_name',
    'rank_type',
    'filter_text',
    'uuid',
    'click_trademark_id',
    'click_activity_id',
    'click_product_id',
    'click_market_id',
    'click_live_status',
    'click_live_no',
    'click_coupons_id',
    'desc',
    'material_id',
    'click_material_type',
    'click_material_id',
    'keyword',
    'search_request_id',
]);

const btn_click = akcAppProperties([
    'page_name',
    'previous_page_name',
    'activity_id',
    'market_id',
    'live_status',
    'live_no',
    'page_desc',
    'tab_name',
    'nums',
    'module',
    'btn_name',
    'btn_text',
    'item_id',
    'rank',
    'desc',
    'material_id',
    'channel',
]);

const resource_click = akcAppProperties([
    'page_name',
    'previous_page_name',
    'activity_id',
    'market_id',
    'live_status',
    'live_no',
    'page_desc',
    'resource_id',
    'resource_name',
    'resource_type',
    'resource_url',
    'tab_name',
    'click_activity_id',
    'click_product_id',
    'click_market_id',
    'click_live_status',
    'click_live_no',
    'click_coupons_id',
    'rank_name',
    'rank_type',
    'filter_text',
    'uuid',
    'resource_rank',
    'btn_name',
    'desc',
    'material_id',
    'click_material_type',
    'click_material_id',
    'click_brand_id',
    'keyword',
    'search_request_id',
    'channel',
]);

const share = akcAppProperties([
    'page_name',
    'previous_page_name',
    'activity_id',
    'market_id',
    'live_status',
    'live_no',
    'page_desc',
    'tab_name',
    'share_type',
    'share_method',
    'click_activity_id',
    'click_product_id',
    'click_market_id',
    'click_live_status',
    'click_live_no',
    'click_coupons_id',
    'click_tag_id',
    'share_channel',
    'share_setting',
    'share_t',
    'share_url',
    'img_type',
    'is_success',
    'reason',
    'rank',
    'nums',
    'choose_type',
    'material_id',
    'click_material_type',
    'click_material_id',
    'search_request_id',
    'coupons_id',
    'coupons_name',
    'coupons_type',
]);

const poster_expose = akcAppProperties([
    'page_name',
    'tab_name',
    'activity_id',
    'market_id',
    'live_status',
    'live_no',
    'type',
    'click_activity_id',
    'click_product_id',
    'click_market_id',
    'click_live_status',
    'click_live_no',
    'click_coupons_id',
    'click_tag_id',
    'expose_content',
]);

var appProps = /*#__PURE__*/Object.freeze({
    __proto__: null,
    pv: pv,
    tab_expose: tab_expose,
    resource_click: resource_click,
    resource_expose: resource_expose,
    btn_click: btn_click,
    share: share,
    poster_expose: poster_expose
});

/* eslint-disable no-unused-vars */

/**
 * yiguan埋点参数
 * @param {*} keys
 */
const akcAppProperties$1 = keys => (to, from) => defaults => {
    if (!to && !from && defaults) {
        defaults = to;
        to = null;
        from = null;
    }
    let market_id;
    let brand_id;
    let product_id;
    let live_no = '';
    if (to && to.query) {
        let {
            conferenceId,
            hotSaleId,
            activityNo,
            productId,
            liveNo,
        } = to.query || {};
        market_id = conferenceId || hotSaleId;
        brand_id = activityNo;
        product_id = productId;
        live_no = liveNo;
    }
    const properties = {
        get page_name() {
            return to && to.meta ? to.meta.pageName : '';
        },
        get previous_page_name() {
            let preName = from && from.meta ? from.meta.pageName : '';
            let name = from ? preName || from.name : '';
            if (!name) {
                name = window.location.href.match(/[?&]previous_page_name=([^&]+)/);
                name = name && window.decodeURIComponent(name && name[1]);
            }
            return name;
        },
        get activity_id() {
            const id = window.location.href.match(/activityNo=([^&]+)/);
            return brand_id || (id ? id[1] : '');
        },
        get brand_id() {
            const id = window.location.href.match(/activityNo=([^&]+)/);
            return brand_id || (id ? id[1] : '');
        },
        get product_id() {
            const id = window.location.href.match(/productId=([^&]+)/);
            return product_id || (id ? id[1] : '');
        },
        get market_id() {
            const id = window.location.href.match(/hotSaleId=([^&]+)|conferenceId=([^&]+)/);
            return market_id || (id ? (id[1] || id[2]) : '');
        },
        get live_status() {
            return '';
        },
        get live_no() {
            const id = window.location.href.match(/liveNo=([^&]+)/);
            return live_no || (id ? id[1] : '');
        },
        get page_desc() {
            return '';
        },
        tab_id: '',
        tab_name: '',
        rank: '',
        nums: '',
        resource_id: '',
        resource_name: '',
        resource_content: '',
        resource_type: '',
        resource_url: '',
        resource_rank: '',
        rank_name: '',
        rank_type: '',
        filter_text: '',
        uuid: '',
        click_activity_id: '',
        click_product_id: '',
        click_market_id: '',
        click_live_status: '',
        click_live_no: '',
        click_coupons_id: '',
        desc: '',
        share_type: '',
        share_method: '',
        click_tag_id: '',
        share_channel: '',
        share_setting: '',
        share_t: '',
        img_type: '',
        is_success: '',
        reason: '',
        choose_type: '',
    };

    const props = { ...properties, ...defaults };
    [
        'click_activity_id',
        'click_product_id',
        'click_market_id',
        'click_coupons_id',
        'market_id',
        'activity_id',
        'tab_id',
        'live_no',
        'resource_id',
    ].forEach(k => {
        props[k] = typeof props[k] === 'number' ? String(props[k]) : props[k];
    });
    return pickBy(pick(props, keys), (v, k) => v !== undefined && v != null && v !== '');
};

const $startup = akcAppProperties$1([
    '$is_first_time',
    '$is_from_background',
    '$duration',
]);

const $end = akcAppProperties$1([
    '$duration',
]);
const filter = akcAppProperties$1([
    'type',
    'page_name',
    'tab_name',
    'min_price',
    'max_price',
    'product_status',
    'category',
    'desc',
    'nums',
]);
const view_other_search_result = akcAppProperties$1([
    'page_name',
    'key_word',
    'nums',
]);
const order_confirm_details = akcAppProperties$1([
    'page_name',
    'market_id',
    'brand_id',
    'product_id',
    'live_no',
    'product_id',
    'sku_id',
    'nums',
]);

const pv$1 = akcAppProperties$1([
    '$url',
    '$url_domain',
    '$is_first_time',
    '$title',
    '$referrer',
    '$referrer_domain',
    '$traffic_source_type',
    '$search_engine',
    '$search_keyword',
    '$social_media',
    '$social_share_from',
    '$scene',
    '$scene_type',
    'page_name',
    'previous_page_name',
    'market_id',
    'brand_id',
    'product_id',
    'live_no',
    'previous_btn_name',
    'page_item_id',
    'page_desc',
    'material_id',
    'channel',
]);

const tab_expose$1 = akcAppProperties$1([
    'page_name',
    'previous_page_name',
    'activity_id',
    'market_id',
    'live_no',
    'page_desc',
    'tab_id',
    'tab_name',
    'rank',
    'nums',
    'page_item_id',
]);

const resource_expose$1 = akcAppProperties$1([
    'page_name',
    'previous_page_name',
    'activity_id',
    'market_id',
    'live_status',
    'live_no',
    'page_desc',
    'tab_name',
    'resource_id',
    'resource_name',
    'resource_content',
    'brand_id',
    'product_id',
    'click_brand_id',
    'resource_type',
    'resource_url',
    'resource_rank',
    'rank',
    'rank_name',
    'rank_type',
    'filter_text',
    'uuid',
    'click_trademark_id',
    'click_activity_id',
    'click_product_id',
    'click_market_id',
    'click_live_status',
    'click_live_no',
    'click_coupons_id',
    'desc',
    'material_id',
    'click_material_type',
    'click_material_id',
    'keyword',
    'search_request_id',
]);

const btn_click$1 = akcAppProperties$1([
    'page_name',
    'tab_name',
    'market_id',
    'brand_id',
    'product_id',
    'live_no',
    'module',
    'btn_name',
    'btn_text',
    'rank',
    'item_id',
    'page_item_id',
    'page_desc',
    'btn_desc',
    'material_id',
    'channel',
]);

const resource_click$1 = akcAppProperties$1([
    'page_name',
    'market_id',
    'brand_id',
    'product_id',
    'live_no',
    'page_desc',
    'resource_type',
    'resource_id',
    'resource_name',
    'rank_name',
    'rank_type',
    'resource_rank',
    'btn_name',
    'desc',
    'click_brand_id',
    'click_product_id',
    'click_live_no',
    'click_coupons_id',
    'resource_url',
    'material_id',
    'click_material_type',
    'click_material_id',
    'click_market_id',
    'keyword',
    'search_request_id',
    'channel',
]);

const $share = akcAppProperties$1([
    '$share_id',
    '$share_level',
    '$share_path',
    '$title',
    '$url',
    'share_t',
    'page_name',
    'tab_name',
    'market_id',
    'brand_id',
    'product_id',
    'live_no',
    'coupons_id',
    'btn_text',
    'share_type',
    'is_default',
    'click_market_id',
    'click_brand_id',
    'click_product_id',
    'click_live_no',
    'click_coupons_id',
    'desc',
    'material_id',
    'click_material_type',
    'click_live_status',
    'click_material_id',
    'search_request_id',
]);

const poster_expose$1 = akcAppProperties$1([
    'page_name',
    'tab_name',
    'market_id',
    'brand_id',
    'product_id',
    'live_no',
    'type',
    'click_brand_id',
    'click_product_id',
    'click_market_id',
    'click_live_status',
    'click_live_no',
    'expose_content',
]);

const enter = akcAppProperties$1([
    '$url',
    'page_name',
    'market_id',
    'brand_id',
    'product_id',
    'live_no',
    'couple_id',
]);

const authorize = akcAppProperties$1([
    'user_id',
]);

const view_search_result = akcAppProperties$1([
    'page_name',
    'brand_id',
    'page_desc',
    'tab_name',
    'keyword',
    'search_type',
    'min_price',
    'max_price',
    'product_status',
    'click_brand_name',
    'rank_name',
    'rank_type',
    'product_nums',
]);

const add_to_cart = akcAppProperties$1([
    'page_name',
    'tab_name',
    'market_id',
    'brand_id',
    'product_id',
    'live_no',
    'click_product_id',
    'click_sku_id',
    'add_cart_amount',
    'search_request_id',
]);

const submit_order_front = akcAppProperties$1([
    'p_p_order_id',
    'type',
]);

const submit_order = akcAppProperties$1([
    '$platform',
    '$session_id',
    '$utm_campaign',
    '$browser',
    'shop_id',
    'serverId',
    'serverRole',
    'shareId',
    'shareRole',
    'order_source',
    'pre_order_id',
    'order_id',
    'total_price',
    'shipping_cost',
    'payment_method',
    'pay_price',
    'is_coupon',
    'coupons_id',
    'coupon_type',
    'coupon_name',
    'coupon_amount',
    'commission_price',
    'shipping_province',
    'shipping_city',
    'shipping_area',
    'is_shopping_cart_submit',
    'product_count',
]);

const submit_order_item_detail = akcAppProperties$1([
    '$platform',
    '$session_id',
    '$utm_campaign',
    '$browser',
    'shop_id',
    'serverId',
    'serverRole',
    'shareId',
    'shareRole',
    'pre_order_id',
    'order_id',
    'sub_order_id',
    'product_id',
    'product_name',
    'product_count',
    'price',
    'first_category',
    'second_category',
    'third_category',
    'sub_order_price',
    'sub_order_pay_price',
    'commission_price',
    'brand_id',
    'brand_name',
]);

const pay_order_item_detail = akcAppProperties$1([
    '$platform',
    '$session_id',
    '$browser',
    'shop_id',
    'serverId',
    'serverRole',
    'shareId',
    'shareRole',
    'pre_order_id',
    'order_id',
    'sub_order_id',
    'product_id',
    'product_name',
    'item_count',
    'price',
    'commission_price',
    'style_id',
    'brand_id',
    'brand_name',
]);

const user_coupon = akcAppProperties$1([
    '$platform',
    '$browser',
    'shop_id',
    'serverId',
    'serverRole',
    'coupons_id',
    'coupon_name',
    'coupon_type',
    'is_manual_pick',
    'is_algorithm',
    'coupon_amount',
]);

const subscription = akcAppProperties$1([
    'type',
    'page_name',
    'tab_name',
    'live_no',
    'brand_id',
    'product_id',
    'is_success',
    'reason',
]);

const live_send = akcAppProperties$1([
    'live_no',
    'live_name',
    'page_name',
    'desc',
    'message_id',
    'is_success',
    'reason',
]);

const live_report = akcAppProperties$1([
    'live_no',
    'live_name',
    'page_name',
    'report_id',
]);

const live_broadcast_duration = akcAppProperties$1([
    'duration_id',
    'enter_the_time',
    'duration_time',
    'leave_the_time',
    'live_no',
    'live_name',
    'page_name',
]);

var h5Props = /*#__PURE__*/Object.freeze({
    __proto__: null,
    pv: pv$1,
    tab_expose: tab_expose$1,
    resource_click: resource_click$1,
    resource_expose: resource_expose$1,
    btn_click: btn_click$1,
    $share: $share,
    poster_expose: poster_expose$1,
    enter: enter,
    authorize: authorize,
    view_search_result: view_search_result,
    submit_order_item_detail: submit_order_item_detail,
    add_to_cart: add_to_cart,
    pay_order_item_detail: pay_order_item_detail,
    user_coupon: user_coupon,
    live_broadcast_duration: live_broadcast_duration,
    live_report: live_report,
    live_send: live_send,
    subscription: subscription,
    submit_order_front: submit_order_front,
    submit_order: submit_order,
    $startup: $startup,
    $end: $end,
    filter: filter,
    view_other_search_result: view_other_search_result,
    order_confirm_details: order_confirm_details
});

const props = type => (type === 'h5' ? h5Props : appProps);

/* eslint-disable no-underscore-dangle */
/**
 * intersection
 */

const computedStyle = window.getComputedStyle || function (el) { return el.style || {}; };

function isHidden(el) {
    if (!el) {
        return true;
    }
    let p = el;
    while (p && p !== document) {
        let s = computedStyle(p);
        if (s.display === 'none' || s.visibility === 'hidden') {
            return true;
        }
        p = p.parentNode;
    }
    return false;
}

const _isInView = (cw, ch) => function (el) {
    if (isHidden(el)) {
        return false;
    }
    let rect = el.getBoundingClientRect();
    let w = rect.width;
    let h = rect.height;
    let { left, top } = rect;
    // 曝光的基本都是小的item模块
    if (w <= cw && h <= ch) {
        return left >= 0 && (0.75 * w + left) <= cw && top >= 0 && (0.75 * h + top) <= ch;
    }
    return false;
};

const _isOutView = (cw, ch) => function (el) {
    if (isHidden(el)) {
        return true;
    }
    let rect = el.getBoundingClientRect();
    return rect.right <= 0 || rect.left >= cw || rect.top >= ch || rect.bottom <= 0;
};

/* eslint-disable no-param-reassign */

const setElData = function (el, data) {
    if (!el.trackData) {
        el.trackData = {};
    }
    if (data && data.type) {
        el.trackData[data.type] = data;
    }
};

const getElData = function (el, type) {
    if (!el.trackData) {
        el.trackData = {};
    }
    return el.trackData[type];
};

// 不处理properties
const _tracker = AnalysysAgent((e, p) => p);

function _buildProperties(type, obj, index) {
    switch (type) {
        case 'banner':
            return {
                resource_id: obj.id,
                resource_name: obj.name,
                resource_url: obj.linkUrl,
                resource_rank: index,
            };
        case 'diamond':
            return {
                resource_id: obj.id,
                resource_name: obj.name,
                resource_url: obj.linkUrl,
                resource_rank: index,
            };
        case 'tab':
            return {
                tab_id: obj.id,
                tab_name: obj.name,
                rank: index || '',
            };
        case 'btn':
            return {
                btn_name: obj.name,
                btn_text: obj.text,
                rank: index || '',
            };
        case 'product':
            return {
                click_product_id: obj.id,
                name: obj.name,
                resource_rank: index,
            };
        case 'activity':
            return {
                click_activity_id: obj.id,
                resource_rank: index,
            };
        case 'coupon':
            return {
                click_coupons_id: obj.id,
                name: obj.name,
            };
        default:
            throw new Error(`type[${type}] has no build case`);
    }
}
/**
 *
 * @param  {...any} props [type, prop],[type, prop],[type, prop]
 */
const buildTrackProperties = function (...props) {
    if (!props.length) return null;
    // console.log(props);
    let properties = {};
    properties = Object.assign(
        ...props.map(p => (Array.isArray(p) ? _buildProperties(...p) : p)),
    );
    return properties;
};

const pageProps = {};

const hookRouter = (router, source) => {
    let props$1 = props(source);
    if (router) {
        router.afterEach((to, from) => {
            Object.keys(props$1).forEach(key => {
                pageProps[key] = props$1[key](to, from);
            });
        });
    } else {
        Object.keys(props$1).forEach(key => {
            pageProps[key] = props$1[key]();
        });
    }
};

const _buildTrackProperties = (type, props) => (pageProps[`${type}`] ? pageProps[`${type}`](props) : props);

const click = (tracker = _tracker) => ({
    inserted(el, binding, vnode) {
        let props = {
            ...vnode.context._trackData,
            ...buildTrackProperties(binding.value.properties),
        };
        setElData(el, { type: binding.value.type, properties: props });
        let { type } = binding.value;
        // console.log('inserted click', binding.value);
        setTimeout(() => {
            el.addEventListener(
                'click',
                function () {
                    let data = getElData(el, type);
                    // console.log('click', data);
                    setTimeout(
                        () => {
                            let p = _buildTrackProperties(type, data.properties);
                            tracker.track(type, p);
                        },
                        0,
                    );
                },
                false,
            );
        }, 400);
    },
    componentUpdated(el, binding, vnode) {
        let props = {
            ...vnode.context._trackData,
            ...buildTrackProperties(binding.value.properties),
        };
        setElData(el, { type: binding.value.type, properties: props });
    },
});

/**
 * 曝光元素
 */

const attrid = 'aktrackid';
// store exposed elements
const exposeElementsMap = {};

let sequence = +new Date();

const sectionView = function (win, doc) {
    let winH = win.innerHeight || doc.documentElement.clientHeight;
    let winW = win.innerWidth || doc.documentElement.clientWidth;
    return {
        interView: _isInView(winW, winH),
        outerView: _isOutView(winW, winH),
    };
};

const expose = (window, doc, tracker = _tracker) => {
    const { interView, outerView } = sectionView(window, doc);

    // only bind one listen
    doc.addEventListener('scroll', debounce(() => {
        let els = [...doc.querySelectorAll('[aktrackid]')];
        if (els) {
            els.forEach(it => {
                let id = it.getAttribute(attrid);
                if (!id) {
                    // eslint-disable-next-line no-plusplus
                    id = ++sequence;
                    it.setAttribute(attrid, id);
                }
                if (interView(it) && !exposeElementsMap[id]) {
                    exposeElementsMap[id] = it;
                    if (!it._once) {
                        it.exposed = 0;
                    }
                }
                if (outerView(it) && exposeElementsMap[id]) {
                    if (!it._once) {
                        it.exposed = 0;
                    }
                    // delete from expose map
                    delete exposeElementsMap[id];
                }
            });
        }
        Object.values(exposeElementsMap).forEach(el => {
            // eslint-disable-next-line eqeqeq
            // console.log('el.exposed', el.exposed);
            if (el.exposed !== 1) {
                const trackData = getElData(el, 'resource_expose');
                if (!trackData) return;
                let props = _buildTrackProperties(
                    trackData.type,
                    buildTrackProperties(trackData.properties),
                );
                tracker.track(trackData.type, props);
                el.exposed = 1;
            }
        });
    }, 600, {
        leading: false,
        trailing: true,
    }), true);

    return {
        inserted(el, binding, vnode) {
            let props = {
                ...vnode.context._trackData,
                ...buildTrackProperties(binding.value.properties),
            };
            let { type } = binding.value;
            setElData(el, { type, properties: props });
            let { once } = binding.modifiers || {};
            // let trackid = el[attrid];
            let trackid = el.getAttribute(attrid);
            if (once) {
                el._once = 1;
            }
            if (!trackid) {
                // eslint-disable-next-line no-plusplus
                trackid = ++sequence;
                el.setAttribute(attrid, trackid);
            }
            setTimeout(() => {
                if (interView(el) && !exposeElementsMap[trackid]) {
                    let data = getElData(el, type);
                    exposeElementsMap[trackid] = el;
                    el.exposed = 1;
                    let p = _buildTrackProperties(type, data.properties);
                    tracker.track(type, p);
                }
            }, 1000);
        },
        componentUpdated(el, binding, vnode) {
            let props = {
                ...vnode.context._trackData,
                ...buildTrackProperties(binding.value.properties),
            };
            setElData(el, { type: binding.value.type, properties: props });
            // console.log('expose update', el.trackData);
        },
        unbind(el) {
            let trackid = el.getAttribute(attrid);
            if (trackid && exposeElementsMap[trackid]) {
                delete exposeElementsMap[trackid];
            }
        },
    };
};

const mixin = (Vue, tracker = _tracker) => {
    Vue.mixin({
        props: {
            // parent trackctx
            trackctx: {
                type: Object,
            },
        },
        computed: {
            _trackData() {
                let parentctx = {};
                if (this.$parent) {
                    parentctx = this.$parent._trackData;
                }
                return {
                    // 父级属性
                    ...parentctx,
                    // 当前页面公共属性
                    ...this.$trackctx(),
                    // 当前父级组件属性
                    ...this.trackctx,
                };
            },
        },
        methods: {
            trackExpose(eventType, ...properties) {
                let ctx = this._trackData;
                return (callback, el) => {
                    let p = {};
                    try {
                        let _props = buildTrackProperties(...properties);
                        let props = { ...ctx, ..._props };
                        if (!el || _isInView(window, document)(el)) {
                            p = _buildTrackProperties(eventType, props);
                            tracker.track(eventType, p);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return callback && callback(p);
                };
            },
            trackEvent(eventType, ...properties) {
                let ctx = this._trackData;
                return callback => {
                    let p = {};
                    try {
                        let _props = buildTrackProperties(...properties);
                        let props = { ...ctx, ..._props };
                        p = _buildTrackProperties(eventType, props);
                        if (eventType === 'pv') {
                            tracker.pageView(p);
                        } else {
                            tracker.track(eventType, p);
                        }
                    } catch (e) {
                        console.error(e);
                    }
                    return callback && callback(p);
                };
            },
            trackClick(eventType, ...properties) {
                return this.trackEvent(eventType, ...properties);
            },
        },
    });

    const buildProperties = (prop, props) => {
        props = props || [];
        if (prop === undefined) {
            if (!props.length) return null;
            let ret = Object.assign(...props);
            return ret;
        }
        props.push(prop);
        return p => buildProperties(p, props);
    };

    // vue实例的track数据
    // 用在vue实例全局共享的track数据
    Vue.prototype.$trackctx = function (properties) {
        let ret = buildProperties(properties);
        if (typeof ret === 'function') {
            this.$trackctx = ret;
        }
        return ret;
    };
};

/**
 * 原生埋点
 */
var native = (buildProperties, AKJS) => ({
    track(eventName, properties) {
        try {
            let props = buildProperties(eventName, properties);
            console.log('native track', eventName, props);
            AKJS.action.dispatch('event.track.action', { name: eventName, params: props });
        } catch (e) {
            console.error(e);
        }
    },
    pageView(properties) {
        try {
            let props = buildProperties('pv', properties);
            console.log('native track pageview', props);
            if (!props || !props.page_name) {
                throw new Error('pageview\'s page_name is blank');
            }
            AKJS.action.dispatch('event.track.pageView', { name: props.page_name, params: props });
        } catch (e) {
            console.error(e);
        }
    },
});

/* eslint-disable camelcase */

// the track utils
const trackerFn = (isNative, AKJS) => (isNative ? build => native(build, AKJS) : AnalysysAgent);
const tracker1 = (isNative, AKJS) => trackerFn(isNative, AKJS)(_buildTrackProperties);
// properties不做处理
const tracker2 = (isNative, AKJS) => trackerFn(isNative, AKJS)((e, p) => p);
/**
 *
 * @param {string} source 端h5/app
 * @param {object} config 易观config, { appkey, debugMode, uploadURL }
 * @param {object} superProperties 配置
 */
const init = (source, config, superProperties, isNative, AKJS) => (Vue, router) => {
    let tracker = tracker2(isNative, AKJS);
    // just call init
    if (!isNative) {
        AnalysysAgent().init(config, superProperties);
    }
    Vue.directive('track-click', click(tracker));
    Vue.directive('track-expose', expose(window, document, tracker));
    if (router) {
        hookRouter(router, source);
    }
    mixin(Vue, tracker);
};

// just for errors
const bindBlank = Vue => {
    console.error('reset track');
    const blankDirective = () => ({
        inserted() {},
        componentUpdated() {},
    });

    let blankClick = blankDirective;
    let blankExpose = blankDirective;

    let blankMixin = () => {
        Vue.mixin({
            props: {
                // parent trackctx
                trackctx: {
                    type: Object,

                },
            },
            methods: {
                trackExpose() {
                    return callback => callback && callback();
                },
                trackClick() {
                    return callback => callback && callback();
                },
                trackEvent() {
                    return callback => callback && callback();
                },
            },
        });

        Vue.prototype.$trackctx = function (properties) {
            if (properties !== undefined) return () => {};
            return {};
        };
    };
    blankMixin();
    Vue.directive('yg-click', blankClick());
    Vue.directive('track-click', blankClick());
    Vue.directive('yg-expose', blankExpose());
    Vue.directive('track-expose', blankExpose());
};

/**
 * options
 * @param {*} Vue
 * @param {*} router
 * @param {*} AKJS
 * @param {*} pv, 返回pv上报属性的函数
 * @param {*} config
 * @param {*} superProperties
 */
const initAppTrack = async ({
    Vue,
    router,
    AKJS,
    pv,
    config,
    superProperties,
    isNative = false,
}) => {
    async function getAppConfig() {
        return AKJS.ready()
            .then(() => Promise.all([AKJS.info.account(), AKJS.info.device()])
                .then(([info1, info2]) => {
                    let userInfo = info1 && info1.data;
                    let deviceInfo = info2 && info2.data;
                    let obj = {
                        userID: userInfo.userID,
                        user_level: userInfo.level,
                        device_id: deviceInfo.deviceId,
                    };
                    if (userInfo.trackSessionId) {
                        console.log(`track, set session_id=${userInfo.trackSessionId}`);
                        obj.session_id = userInfo.trackSessionId;
                    }
                    if (userInfo.currentRoleType) {
                        console.log(`track, set user_category=${userInfo.currentRoleType}`);
                        obj.user_category = userInfo.currentRoleType;
                    }
                    if (userInfo.shopId) {
                        console.log(`track, set shop_id=${userInfo.shopId}`);
                        obj.shop_id = userInfo.shopId;
                    }
                    return obj;
                }))
            .then(sp => [
                {
                    appkey: process.env.VUE_APP_ARK_APPKEY,
                    debugMode: parseInt(process.env.VUE_APP_ANALYSYS_DEBUGMODE, 10) || 0,
                    uploadURL: 'https://ark-collector.aikucun.com',
                    ...config,
                },
                {
                    ...sp,
                    ...superProperties,
                },
            ]);
    }
    return getAppConfig()
        .catch(e => {
            console.error(e);
        })
        .then(([cfg, sp]) => {
            init('app', cfg, sp, isNative, AKJS)(Vue, router);
            let tracker = tracker1(isNative, AKJS);
            if (router) {
                router.afterEach((to, from) => {
                    let page_name = to.meta && to.meta.page_name;
                    let previous_page_name = from.meta && from.meta.page_name;
                    if (!previous_page_name) {
                        let pre = window.location.href.match(/[?&]previous_page_name=([^&]+)/);
                        previous_page_name = pre && decodeURIComponent(pre && pre[1]);
                    }
                    let pvprops = { page_name, previous_page_name };
                    if (pv) {
                        // 获取自定义pv属性
                        let props = pv(to, from);
                        pvprops = {
                            ...pvprops,
                            ...props,
                        };
                        // pv返回false不上报pageview
                        if (props !== false) {
                            tracker.pageView(pvprops);
                        }
                    } else {
                        tracker.pageView(pvprops);
                    }
                });
            } else if (pv) {
                let pvprops = pv();
                if (pvprops !== false) {
                    let pre = pvprops && pvprops.previous_page_name;
                    if (!pre) {
                        pre = window.location.href.match(/[?&]previous_page_name=([^&]+)/);
                        pre = pre && decodeURIComponent(pre && pre[1]);
                    }
                    tracker.pageView({
                        ...pvprops,
                        ...{ previous_page_name: pre },
                    });
                }
            }
        })
        .catch(e => {
            console.error('init track error');
            console.error(e);
            bindBlank(Vue);
        });
};

// 非native浏览器端tracker
const webTracker = tracker1(false);

export { bindBlank, _buildTrackProperties as buildProperties, initAppTrack, init as initTrack, webTracker as tracker };
